import { useMutation } from "src/Hooks/useReactQuery";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import routeGuard from "src/HOC/routeGuard";
import FormFlightSimulator, { FORM_NAME } from "src/components/FlightSimulator/form";
import APP_ROUTES from "src/routes/routes";
import { createSimulator } from "src/services/simulator-flight";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { RESOURCE_TYPE, ROLES } from "src/constant/common";

const FlightSimulator = () => {
  const { t } = useTranslation("flight-simulator");
  const navigate = usePatchedNavigate();
  const showAlert = useSetRecoilState(alertState);
  const [errorMessages, setErrorMessages] = useState([]);
  const data = {
    [FORM_NAME.NAME]: "",
    [FORM_NAME.TYPE]: "",
    [FORM_NAME.VERSION]: "",
    [FORM_NAME.EXECUTION]: "",
    [FORM_NAME.NOTE]: "",
    [FORM_NAME.PARAMS]: [],
    [FORM_NAME.INPUTS]: [],
    [FORM_NAME.FILE_RESPONSE]: "",
    [FORM_NAME.SERIES]: [],
  };

  const createSimulatorMutate = useMutation({
    mutationFn: ({ data }) => createSimulator({ data }),
  });

  const submitData = ({ data }, callback) =>
    createSimulatorMutate.mutate(
      { data },
      {
        onSuccess: () => {
          setErrorMessages([]);
          showAlert({
            status: true,
            message: t("new.create_success"),
            type: "success",
          });
          navigate(APP_ROUTES.HOME);
        },
        onError: (error) => {
          const apiErrorMessages = error?.response?.data?.error?.detail;

          if (apiErrorMessages && Array.isArray(apiErrorMessages)) {
            setErrorMessages(apiErrorMessages);

            showAlert({
              status: true,
              message: t("new.create_failed"),
              type: "danger",
            });
          }
        },
        onSettled: () => callback(),
      }
    );

  return <FormFlightSimulator submitData={submitData} data={data} errorMessages={errorMessages} />;
};

export default routeGuard(FlightSimulator, RESOURCE_TYPE.FLIGHT_SIMULATION, ROLES.EDITOR);
